module.exports = __webpack_public_path__ + "media/images/official/special_sightseen_17-800dece97d23e7c3891e0c0b8db84f48.jpg";